import React from 'react'
import {CondominiumInfo} from '../../condominium/repository/NatGetCondominiumList'
import {TableCell, TableRow} from '@mui/material'
import {PREFECTURES_MASTER} from '../../../../CodeMaster'
import {DeleteLink} from '../../../../styledComponents/adminPage/Links'
import withStyles from '@mui/styles/withStyles'
import {LightGrayTableHeadColor} from '../../../../styledComponents/adminPage/Table'

interface Props {
    condominium: CondominiumInfo
    onClickDeleteCondominium: (condominiumCd: string) => void
}

const NatAdminDisasterCondominiumRecode: React.FC<Props> = React.memo(props => {
    const {
        condominium,
        onClickDeleteCondominium
    } = props

    return (
        <TableRow key={condominium.condominiumCd}>
            <TableSelectCell>{condominium.condominiumCd}</TableSelectCell>
            <TableSelectCell>{condominium.condominiumName}</TableSelectCell>
            <TableSelectCell>{condominium.condominiumGroupName}</TableSelectCell>
            <TableSelectCell>{PREFECTURES_MASTER.codeToEnumConstants(condominium.prefectureCd).label}</TableSelectCell>
            <TableSelectCell>{condominium.address2}</TableSelectCell>
            <TableDeleteCell>
                <DeleteLink onClick={() => onClickDeleteCondominium(condominium.condominiumCd)}/>
            </TableDeleteCell>
        </TableRow>
    )
})

const TableHeaderCell = withStyles({
    root: {
        backgroundColor: LightGrayTableHeadColor,
        lineHeight: '20px',
        height: '49px',
        padding: '0 12px',
        border: 'none'
    }
})(TableCell)

const TableSelectCell = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        whiteSpace: 'pre-wrap',
        overflowWrap: 'anywhere'
    }
})(TableHeaderCell)

const TableDeleteCell = withStyles({
    root: {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        paddingLeft: 0
    }
})(TableHeaderCell)

NatAdminDisasterCondominiumRecode.displayName = 'NatAdminDisasterCondominiumRecode'
export default NatAdminDisasterCondominiumRecode